import { useDataSubmit } from 'Simple/Data'

export function useOnSubmit(props) {
  let submit = useDataSubmit({
    context: 'copy_charges',
    viewPath: props.viewPath,
  })

  return function onSubmit(value) {
    submit({ location_ids: value })

    if (typeof props.closePopover === 'function') props.closePopover()
  }
}
